<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <!-- Subscription -->
    <div v-if="userProfile.isProcessingPayment">
      <b-message
        type="is-info"
        has-icon
      >
        Seu pagamento encontra-se em processamento. Aguarde a aprovação para a ativação do plano premium.
      </b-message>
    </div>
    <div v-else>
      <div
        v-if="!isPremium"
        class="login-page"
      >
        <!-- Subscription Form -->
        <form @submit.prevent="subscribeForPremium">
          <section>
            <h2 class="mb-4">Assinar Plano Premium</h2>
            <section>
              <h3 class="title-left-border">Escolha de Plano</h3>
              <hr>
              <div class="rounded h-full flex flex-wrap items-center text-center">
                <div
                  v-for="plan in plans"
                  :key="plan.id"
                >
                  <a
                    href="javascript:void(0)"
                    class="rounded bg-white shadow-md h-48 w-48 p-6 flex flex-col justify-around m-2 scale-hover border-green-800"
                    :class="{'border-solid': selectedPlan.id == plan.id}"
                    @click="selectPlan(plan)"
                    v-if="plan.active && plan.pagseguro && plan.pagseguro.code"
                  >
                    <div>
                      <p class="text-lg text-base text-grey-dark">{{plan.name}}</p>
                    </div>
                    <div>
                      <p class="text-2xl text-grey-darker font-bold">{{plan.amountPerPayment}}</p>
                    </div>
                    <div>
                      <p class="text-base text-grey-dark">
                        {{
                            plan.period == 'MONTHLY' && 'Mensal' ||
                            plan.period == 'WEEKLY' && 'Semanal' ||
                            plan.period == 'BIMONTHLY' && 'Bimestral' ||
                            plan.period == 'TRIMONTHLY' && 'Trimestral' ||
                            plan.period == 'SEMIANNUALLY' && 'Semestral' ||
                            plan.period == 'YEARLY' && 'Anual'
                          }}
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </section>
            <section v-if="selectedPlan && selectedPlan.id">
              <h3 class="title-left-border">Dados do Comprador</h3>
              <hr>
              <div class="columns is-multiline">
                <!-- Nome -->
                <b-field
                  label="Nome Completo *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="sender.name"
                    placeholder="NOME COMPLETO"
                    required
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    maxlength="50"
                    validation-message="Insira um nome válido"
                  />
                </b-field>

                <!-- Email -->
                <b-field
                  label="Email *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="sender.email"
                    placeholder="EMAIL"
                    type="email"
                    required
                  />
                </b-field>

                <!-- CPF -->
                <b-field
                  label="CPF *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="sender.documents[0].value"
                    plCancelaraceholder="CPF"
                    required
                    maxlength="11"
                    validation-message="Informe apenas os números de um CPF válido"
                    pattern="^\d{11}"
                  />
                </b-field>

                <!-- Data de Nascimento -->
                <b-field
                  label="Nascimento *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.birthDate"
                    placeholder="dd/mm/aaaa"
                    required
                    type="tel"
                    v-mask="'##/##/####'"
                    validation-message="Informe uma data no formato dd/mm/aaaa"
                    pattern="^\d{2}\/\d{2}\/\d{4}$"
                  />
                </b-field>

                <!-- DDD -->
                <b-field
                  label="DDD *"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    v-model="sender.phone.areaCode"
                    placeholder="CÓDIGO DE ÁREA"
                    required
                    validation-message="Informe um DDD Válido"
                    pattern="[0-9][0-9]"
                    maxlength="2"
                  />
                </b-field>

                <!-- Telefone -->
                <b-field
                  label="Telefone *"
                  class="column is-12 is-3-desktop"
                >
                  <b-input
                    v-model="sender.phone.number"
                    placeholder="NÚMERO"
                    required
                    maxlength="9"
                    :has-counter="false"
                    validation-message="Informe um Telefone Válido"
                    pattern="(0?[1-9]{2})*\D*(9?)\D?(\d{4})+\D?(\d{4})\b"
                  />
                </b-field>

                <!-- Logradouro -->
                <b-field
                  label="Logradouro *"
                  class="column is-12 is-3-desktop"
                >
                  <b-input
                    :value="sender && sender.address.street"
                    v-model="sender.address.street"
                    placeholder="LOGRADOURO"
                    required
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ0-9 ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>

                <!-- Numero -->
                <b-field
                  label="Número *"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    :value="sender && sender.address.number"
                    v-model="sender.address.number"
                    placeholder="N"
                    type="tel"
                    required
                  />
                </b-field>

                <!-- Complemento -->
                <b-field
                  label="Complemento"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="sender.address.complement"
                    placeholder="COMPLEMENTO"
                  />
                </b-field>

                <!-- Bairro -->
                <b-field
                  label="Bairro *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="sender.address.district"
                    placeholder="BAIRRO"
                    required
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>

                <!-- CEP -->
                <b-field
                  label="CEP *"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="sender.address.postalCode"
                    placeholder="CEP"
                    pattern="^\d{8}"
                    maxlength="8"
                    validation-message="Informe apenas os número do CEP"
                  />
                </b-field>

                <!-- Cidade -->
                <b-field
                  label="Cidade *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="sender.address.city"
                    placeholder="CIDADE"
                    required
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>

                <!-- Estado -->
                <b-field
                  label="Estado *"
                  class="column is-12 is-2-desktop"
                >
                  <b-select
                    placeholder="Estado"
                    v-model="sender.address.state"
                    required
                  >
                    <option
                      v-for="option in states"
                      :value="option.acronym"
                      :key="option.id"
                    >
                      {{ option.acronym }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </section>
            <section v-if="selectedPlan && selectedPlan.id">
              <h3 class="title-left-border">Cartão de Crédito</h3>
              <hr>

              <div class="columns is-multiline">
                <b-field
                  label="Nome no Cartão *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    required
                    v-model="creditCard.name"
                  />
                </b-field>
                <b-field
                  label="Número do Cartão *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    type="tel"
                    required
                    v-model="creditCard.number"
                    v-mask="['#### #### #### ####']"
                  />
                </b-field>

                <b-field
                  label="Mês *"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    type="tel"
                    required
                    v-model="creditCard.month"
                    v-mask="['##']"
                    placeholder="01"
                  />
                </b-field>
                <b-field
                  label="Ano *"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    type="tel"
                    placeholder="2020"
                    required
                    pattern="\d{4}"
                    v-model="creditCard.year"
                    v-mask="['####']"
                  />
                </b-field>

                <b-field
                  label="CVC *"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    type="tel"
                    required
                    v-model="creditCard.cvv"
                    v-mask="['###', '###']"
                    placeholder="123"
                  />
                </b-field>

              </div>

              <h3 class="title-left-border">Usuário do Cartão</h3>
              <hr>
              <b-switch
                v-model="isHolderEqualsSender"
                class="column is-12 mb-4"
              >
                Utilizar mesmos dados do comprador
              </b-switch>

              <hr />
              <div
                class="columns is-multiline"
                v-if="!isHolderEqualsSender"
              >

                <!-- Nome -->
                <b-field
                  label="Nome *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.name"
                    placeholder="NOME COMPLETO"
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    maxlength="50"
                    validation-message="Insira um nome válido"
                  />
                </b-field>

                <!-- Data de Nascimento -->
                <b-field
                  label="Nascimento *"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.birthDate"
                    placeholder="dd/mm/aaaa"
                    type="tel"
                    v-mask="'##/##/####'"
                    validation-message="Informe uma data no formato dd/mm/aaaa"
                    pattern="^\d{2}\/\d{2}\/\d{4}$"
                  />
                </b-field>

                <b-field
                  label="CPF"
                  class="column is-12 is-4-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.documents[0].value"
                    plCancelaraceholder="CPF"
                    maxlength="11"
                    validation-message="Informe apenas os números de um CPF válido"
                    pattern="^\d{11}"
                  />
                </b-field>

                <b-field
                  label="DDD"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.phone.areaCode"
                    placeholder="CÓDIGO DE ÁREA"
                    validation-message="Informe um DDD Válido"
                    pattern="[0-9][0-9]"
                    maxlength="2"
                  />
                </b-field>
                <b-field
                  label="Telefone"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.phone.number"
                    placeholder="NÚMERO"
                    maxlength="9"
                    :has-counter="false"
                    validation-message="Informe um Telefone Válido"
                    pattern="(0?[1-9]{2})*\D*(9?)\D?(\d{4})+\D?(\d{4})\b"
                  />
                </b-field>

                <b-field
                  label="Logradouro"
                  class="column is-12 is-3-desktop"
                >
                  <b-input
                    :value="sender && creditCard.holder.billingAddress.street"
                    v-model="creditCard.holder.billingAddress.street"
                    placeholder="LOGRADOURO"
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>
                <b-field
                  label="Número"
                  class="column is-12 is-1-desktop"
                >
                  <b-input
                    :value="sender && creditCard.holder.billingAddress.number"
                    v-model="creditCard.holder.billingAddress.number"
                    placeholder="N"
                    type="tel"
                  />
                </b-field>

                <b-field
                  label="Complemento"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.billingAddress.complement"
                    placeholder="COMPLEMENTO"
                  />
                </b-field>
                <b-field
                  label="Bairro"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.billingAddress.district"
                    placeholder="BAIRRO"
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>
                <b-field
                  label="CEP"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.billingAddress.postalCode"
                    placeholder="CEP"
                    pattern="^\d{8}"
                    maxlength="8"
                    validation-message="Informe apenas os número do CEP"
                  />
                </b-field>
                <b-field
                  label="Cidade"
                  class="column is-12 is-2-desktop"
                >
                  <b-input
                    v-model="creditCard.holder.billingAddress.city"
                    placeholder="CIDADE"
                    pattern="^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                    validation-message="Insira um nome válido"
                  />
                </b-field>
                <b-field
                  label="Estado"
                  class="column is-12 is-1-desktop"
                >
                  <b-select
                    placeholder="Estado"
                    v-model="creditCard.holder.billingAddress.state"
                  >
                    <option
                      v-for="option in states"
                      :value="option.acronym"
                      :key="option.id"
                    >
                      {{ option.acronym }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </section>

            <div class="columns flex flex-col">
              <span class="column">
                <b-button
                  native-type="submit"
                  type="is-primary"
                  class="mr-4"
                  :disabled="!(selectedPlan && selectedPlan.id)"
                >
                  Assinar
                </b-button>

              </span>
              <span class="mt-8">
                <img
                  class="h-16"
                  src="../../assets/img/pagseguro.png"
                  alt=""
                >
              </span>
            </div>
          </section>
        </form>
      </div>
      <div v-else>
        <section>
          <h2>Assinatura</h2>
          <b-message
            type="is-success"
            has-icon
          >
            <b>Seu plano premium foi ativado com sucesso!</b>
            <br />Você já tem acesso aos recursos exclusivos de usuários Premium.
            <br />A renovação de seu plano será realizada automaticamente de forma recorrente.
          </b-message>
          <ul>
            <li v-if="plan.activation">Data de Ativação: {{plan.activation | formatDate(true)}} </li>
            <li v-if="plan.expiration">Data de Expiração: {{plan.expiration | formatDate(true)}}</li>
            <li v-if="plan.renewalType">Tipo de Renovação: {{plan.renewalType | formatDate(true)}}</li>
          </ul>
          <b-button
            @click="cancelPremiumSubscription"
            type="is-danger"
            class="mr-4 mt-8"
          >
            Cancelar Plano
          </b-button>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import pagseguro from '@/pagseguro'
import { functions } from '../../firebaseConfig'
import { states } from '../../utils/states'
import { formatDateMixin } from '../../mixins/filters.js'

const DEBUG = process.env.NODE_ENV === 'development'

export default {

  mixins: [formatDateMixin],

  data () {
    return {
      formData: {},
      selectedPlan: {},
      states,
      plan: {
        activation: '',
        expiration: '',
        renewalType: ''
      },
      isHolderEqualsSender: true,
      VCreditCardTranslation: {
        name: { label: 'Nome', placeholder: 'Nome Completo' },
        card: { label: 'Número do Cartão', placeholder: 'Número do Cartão' },
        expiration: { label: 'Validade' },
        security: {
          label: 'CVV/CCV',
          placeholder: 'Código'
        }
      },
      sender: {
        address: {
          city: '',
          country: 'BRA',
          district: '',
          number: '',
          complement: '',
          postalCode: '',
          state: '',
          street: ''
        },
        documents: [{
          type: 'CPF',
          value: ''
        }],
        email: '',
        hash: '',
        name: '',
        phone: {
          areaCode: '',
          number: ''
        }
      },
      creditCard: {
        holder: {
          billingAddress: {
            city: '',
            country: 'BRA',
            district: '',
            number: '',
            complement: '',
            postalCode: '',
            state: '',
            street: ''
          },
          documents: [{
            type: 'CPF',
            value: ''
          }],
          name: '',
          phone: {
            areaCode: '',
            number: ''
          },
          birthDate: ''
        },
        cvv: '',
        month: '',
        name: '',
        number: '',
        token: '',
        year: ''
      },
      pagseguro: null,
      showForm: false
    }
  },
  computed: {
    ...mapState({
      isPremium: 'isPremium',
      performingRequest: 'performingRequest',
      professionalProfile: 'professionalProfile',
      userProfile: 'userProfile',
      currentUser: 'currentUser',
      activeDashboardSection: 'activeDashboardSection',
      pagseguroSessionId: state => state.pagseguro.sessionId,
      plans: 'plans'
    })
  },
  watch: {
    'userProfile' () {
      this.updateSenderData()
    },
    'professionalProfile' () {
      this.updateSenderAddress()
    }
  },
  async created () {
    this.$store.commit('setPerformingRequest', true)
    await this.$store.dispatch('fetchPremiumStatus')
    await this.$store.dispatch('fetchPlans')
    this.updateSenderData()
    this.updateSenderAddress()

    if (this.isPremium) {
      this.$store.commit('setPerformingRequest', false)
      return
    }

    const pagseguro = document.createElement('script')

    let jsSrc

    process.env.NODE_ENV === 'development'
      ? jsSrc = 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js'
      : jsSrc = 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js'

    pagseguro.setAttribute(
      'src',
      jsSrc
    )

    document.head.appendChild(pagseguro)

    setTimeout(async () => {
      this.pagseguro = window.PagSeguroDirectPayment

      try {
        await this.$store.dispatch('pagseguro/createSessionId')
        this.pagseguro.setSessionId(this.pagseguroSessionId)
      } catch (error) {
        DEBUG && console.error(error)
      } finally {
        this.$store.commit('setPerformingRequest', false)
        this.showForm = true
      }
    }, 1000)
  },
  methods: {
    selectPlan (plan) {
      this.selectedPlan = plan
    },
    updateSenderData () {
      this.sender.name = `${this.userProfile.name.trim()} ${this.userProfile.lastName.trim()}`
      this.sender.email = DEBUG
        ? `${this.userProfile.email.split('@')[0]}@sandbox.pagseguro.com.br`
        : this.userProfile.email
    },
    updateSenderAddress () {
      const { city, neighborhood, number, state, street } = this.professionalProfile.address
      this.sender.address = {
        city,
        country: 'BRA',
        complement: '',
        district: neighborhood,
        number,
        postalCode: '83321020',
        state: state,
        street
      }
    },
    creditInfoChanged (values) {
      this.cvv = values.security
      this.name = values.name
      this.month = values.expiration.split('/')[0]
      this.year = values.expiration.split('/')[1]
    },
    async subscribeForPremium () {
      const {
        cvv,
        month,
        name,
        number,
        year
      } = this.creditCard

      if (!(cvv && month && name && number && year)) {
        return this.$toasted.error('Informe todos os dados do cartão e tente novamente.')
      }

      try {
        this.$store.commit('setPerformingRequest', true)
        await Promise.all([this.getHash(), this.createCardToken()])
        await this.submitRequest()
      } catch (error) {
        DEBUG && console.error(error)
      } finally {
        this.$store.commit('setPerformingRequest', false)
      }
    },
    async getHash () {
      try {
        this.sender.hash = await pagseguro.getSenderHash(this.pagseguro)
      } catch (error) {
        DEBUG && console.error(error)
      } finally {
        this.$store.commit('setPerformingRequest', false)
      }
    },
    async createCardToken () {
      let {
        cvv,
        month,
        name,
        number,
        year
      } = this.creditCard

      cvv = cvv.replace(/\D/g, '')
      month = month.replace(/\D/g, '')
      number = number.replace(/\D/g, '')
      year = year.replace(/\D/g, '')

      try {
        this.creditCard.token = await pagseguro.createCardToken(
          this.pagseguro,
          {
            cvv,
            month,
            name,
            number,
            year
          })
      } catch (error) {
        DEBUG && console.error('createCardToken error', error)
        this.$toasted.error('Erro ao validar o cartão. Verifique os dados e tente novamente')
      } finally {
        this.$store.commit('setPerformingRequest', false)
      }
    },
    getHolderData () {
      if (!this.isHolderEqualsSender) {
        return this.creditCard.holder
      }

      const { documents, name, phone } = this.sender
      return {
        billingAddress: this.sender.address,
        birthDate: this.creditCard.holder.birthDate,
        documents,
        name,
        phone
      }
    },
    async submitRequest () {
      try {
        const holder = this.getHolderData()
        const { token } = this.creditCard

        this.$store.commit('setPerformingRequest', true)

        const params = {
          sender: this.sender,
          creditCard: { holder, token },
          token: this.creditCard.token,
          selectedPlan: this.selectedPlan.pagseguro.code
        }

        const { data } = await functions.httpsCallable('pagseguro/plan')(params)
        if (data.success) {
          this.$toasted.success('Dados enviados com sucesso!')
          this.$store.dispatch('setPaymentProcessing', true)
        } else if (data.errors) {
          data.errors.forEach(error => this.$toasted.error(error))
        }
      } catch (error) {
        DEBUG && console.error(error)
        this.$toasted.error('Um erro ocorreu. Tente novamente mais tarde')
      }
    },
    async cancelPremiumSubscription () {
      try {
        this.$store.commit('setPerformingRequest', true)
        const { data } = await functions.httpsCallable('pagseguro/cancel')()

        if (data.success) {
          this.$toasted.success('Assinatura cancelada com sucesso')
        } else if (data.errors) {
          data.errors.forEach(error => this.$toasted.error(error))
        }
      } catch (error) {
        this.$toasted.error('Um erro ocorreu. Tente novamente mais tarde')
        DEBUG && console.error(error)
      } finally {
        this.$store.commit('setPerformingRequest', false)
      }
    }
  }
}

</script>

<style lang="scss">
img.preview {
  width: 200px;
}
.vue-credit-card {
  margin: unset !important;
  justify-content: unset;

  label {
    font-size: 1rem !important;
    font-weight: 700;
  }
}

.vue-credit-card,
.vue-credit-card .card-form-and-image {
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: left !important;
}

.card-form-and-image {
  flex-direction: row !important;
  width: 100%;
}
</style>
